import { FastField, Field, Form, withFormik } from "formik"
import { useEffect } from "react"
import { connect } from "react-redux"
import { Redirect, withRouter } from "react-router-dom"
import * as Yup from "yup"
import { logInUser } from "../../../_actions/userActionCreator"
import { API } from "../../../api"
import {
  BarangayField,
  CityField,
  CountryField,
  CurrencyField,
  ImageField,
  IndustryField,
  MapField,
  StateField,
  TextField,
  TimezoneField
} from "../../../common/Fields"
import {
  ROUTES,
  cacheData,
  getCachedData,
  sessionData
} from "../../../common/utils"
import "./CreateAccountForm.css"
import React from "react"

function CreateAccountBaseForm(props) {
  const {
    values,
    isSubmitting,
    hasSellerAccount,
    hasUserInfo,
    hasLatLng,
    setFieldValue,
    oldAccNoBrgy
  } = props
  useEffect(
    () => {
      if (
        values.country.value &&
        values.country.value.toLowerCase() !== "philippines" &&
        values.city.hasOwnProperty("value")
      ) {
        setFieldValue("city", "")
        setFieldValue("barangay", "")
      }
    },
    [values.country.value, values.city, setFieldValue]
  )
  if (!hasUserInfo && hasLatLng && hasSellerAccount) {
    return (
      <Redirect
        to={{
          pathname: ROUTES.USER_INFO,
          state: { from: props.location }
        }}
      />
    )
  } else if (hasUserInfo && hasLatLng && hasSellerAccount && !oldAccNoBrgy) {
    return (
      <Redirect
        to={{
          pathname: ROUTES.ADMIN,
          state: { from: props.location }
        }}
      />
    )
  }

  const onTinChange = e => {
    const { setFieldValue } = props
    let tin = e.target.value
    if (tin.length > 3 && values.country.value === "philippines") {
      let removeHyphens = tin.split("-").join("")
      let val = removeHyphens.match(new RegExp(".{1,4}$|.{1,3}", "g")).join("-")
      setFieldValue("tin", val)
    } else {
      setFieldValue("tin", tin)
    }
  }
  const onFormKeyDown = e => {
    if (e && e.keyCode === 13) {
      e.preventDefault()
    } else {
      return e
    }
  }
  return (
    <Form onKeyDown={onFormKeyDown} className="CreateAccountForSeller">
      <div className="BusinessLogo">
        <span>
          <label>Business Logo</label>
          {/* Using ImageField */}
          <FastField
            component={ImageField}
            name="logo"
            source="account"
            value={values.logo}
          />
        </span>
      </div>
      <div className="BusinessProfile">
        <span className="line">
          <label>Business Name</label>
          <FastField
            component={TextField}
            type="text"
            name="name"
            placeholder="Your Business Name"
            value={values.name}
          />
        </span>
        <span className="line">
          <label>Address Line 1</label>
          <FastField
            component={TextField}
            type="text"
            name="address1"
            placeholder="Street and number, P.O box, c/o"
            value={values.address1}
          />
        </span>
        <span className="line">
          <label>Address Line 2 (Optional)</label>
          <FastField
            component={TextField}
            type="text"
            name="address2"
            placeholder="Apartment, suite, unit, building, floor, etc."
            value={values.address2}
          />
        </span>
        <span>
          <label>Country</label>
          <FastField
            component={CountryField}
            name="country"
            type="text"
            value={values.country}
          />
        </span>
        <span>
          <label>Province/State</label>
          <Field
            component={StateField}
            name="state"
            type="text"
            countryname={values.country.value}
            value={values.state}
          />
        </span>
        <span>
          <label>City</label>
          {(values.country.value &&
            values.country.value.toLowerCase() === "philippines" && (
              <Field
                name="city"
                component={CityField}
                value={values.city}
                type="text"
                statename={values.state.value}
              />
            )) || (
            <FastField
              component={TextField}
              type="text"
              name="city"
              placeholder="City"
              value={
                values.city.hasOwnProperty("value")
                  ? values.city.value
                  : values.city
              }
            />
          )}
        </span>
        <span>
          <label>Zip Code</label>
          <FastField
            component={TextField}
            type="text"
            name="zipcode"
            placeholder="0000"
            value={values.zipcode}
          />
        </span>
        {values.country.value &&
          values.country.value.toLowerCase() === "philippines" && (
            <div>
              <span>
                <label>Barangay</label>
                <Field
                  name="barangay"
                  component={BarangayField}
                  value={values.barangay}
                  type="text"
                  cityname={values.city.value}
                />
              </span>
            </div>
          )}
        <span className="line">
          <Field component={MapField} name="map" />
        </span>
        <span className="line">
          <label>Industry</label>
          <FastField
            component={IndustryField}
            name="industry"
            type="text"
            value={values.industry}
          />
        </span>
        <span className="line">
          <label>Business TIN (Optional)</label>
          <Field
            component={TextField}
            type="text"
            name="tin"
            placeholder={
              values.country.value === "philippines" ? "000-000-000-000" : null
            }
            value={values.tin}
            onChange={onTinChange}
          />
        </span>
      </div>
      <h2>BUSINESS SETTINGS</h2>
      <div className="BusinessSettings">
        <div className="timezone">
          <label>Timezone</label>
          <FastField
            component={TimezoneField}
            name="timezone"
            type="text"
            value={values.timezone}
          />
        </div>
        <span>
          <label>Currency</label>
          <FastField
            component={CurrencyField}
            name="currency"
            type="text"
            value={values.currency}
          />
        </span>
      </div>
      <div className="form-submit">
        <button type="submit">{isSubmitting ? "Submitting" : "Submit"}</button>
      </div>
    </Form>
  )
}

const CreateAccountForm = withFormik({
  mapPropsToValues: ({ currentUser }) => ({
    name: (currentUser.seller && currentUser.seller.name) || "",
    address1: (currentUser.address && currentUser.address.address_line_1) || "",
    address2: (currentUser.address && currentUser.address.address_line_2) || "",
    barangay:
      (currentUser.address &&
        currentUser.address.barangay && {
          value: currentUser.address && currentUser.address.barangay,
          label: currentUser.address && currentUser.address.barangay
        }) ||
      "",
    city:
      (currentUser.address &&
        currentUser.address.city &&
        (currentUser.address.country.toLowerCase() === "philippines"
          ? {
              value: currentUser.address && currentUser.address.city,
              label: currentUser.address && currentUser.address.city
            }
          : currentUser.address.city)) ||
      "",
    zipcode: (currentUser.address && currentUser.address.zipcode) || "",
    country:
      (currentUser.address &&
        currentUser.address.country && {
          value: currentUser.address && currentUser.address.country,
          label: currentUser.address && currentUser.address.country
        }) ||
      "",
    state:
      (currentUser.address &&
        currentUser.address.province && {
          value: currentUser.address && currentUser.address.province,
          label: currentUser.address && currentUser.address.province
        }) ||
      "",
    tin: (currentUser.seller && currentUser.seller.tin) || "",
    map:
      (currentUser.address &&
        currentUser.address.lat &&
        currentUser.address.lng && {
          formatted_address: null,
          lat:
            currentUser.address &&
            currentUser.address.lat &&
            parseFloat(currentUser.address.lat),
          lng:
            currentUser.address &&
            currentUser.address.lng &&
            parseFloat(currentUser.address.lng),
          place_id: currentUser.address && currentUser.address.place_id
        }) ||
      null,
    industry:
      (currentUser.seller &&
        currentUser.seller.industry && {
          value: currentUser.seller && currentUser.seller.industry,
          label: currentUser.seller && currentUser.seller.industry
        }) ||
      "",
    timezone:
      (currentUser.seller &&
        currentUser.seller.timezone && {
          value: currentUser.seller && currentUser.seller.timezone,
          label: currentUser.seller && currentUser.seller.timezone
        }) ||
      "",
    currency:
      (currentUser.seller &&
        currentUser.seller.currency && {
          value: currentUser.seller && currentUser.seller.currency,
          label: currentUser.seller && currentUser.seller.currency
        }) ||
      "",
    logo: (currentUser.seller && currentUser.seller.logo) || ""
  }),
  validationSchema: Yup.object().shape({
    name: Yup.string().required("Please enter a business name."),
    address1: Yup.string().required("Please enter an address."),
    address2: Yup.string(),
    city: Yup.string().required("Please enter a city."),
    zipcode: Yup.string()
      .min(3, "Please enter a valid zip code.")
      .max(5, "Please enter a valid zip code.")
      .required("Please enter a zip code."),
    country: Yup.object().required("Please select a country."),
    state: Yup.object().required("Please select a state."),
    industry: Yup.string().required("Please select an industry."),
    timezone: Yup.string().required("Please select a timezone."),
    currency: Yup.string().required("Please select a currency."),
    tin: Yup.string().when(
      "country",
      country =>
        country && country.value === "philippines"
          ? Yup.string()
              .min(9, "Please enter a valid tin number.")
              .max(15, "Please enter a valid tin number.")
          : Yup.string()
    ),
    barangay: Yup.string().when(
      "country",
      country =>
        country && country.value === "philippines"
          ? Yup.object().required("Please select a barangay.")
          : Yup.object()
    ),
    logo: Yup.string(),
    map: Yup.object().nullable()
  }),
  handleSubmit: async (values, { props, setSubmitting, setErrors }) => {
    const accountData = {
      name: values.name || null,
      address1: values.address1 || null,
      address2: values.address2 || null,
      barangay: values.barangay.value || null,
      city: values.city.hasOwnProperty("value")
        ? values.city.value
        : values.city,
      zipcode: values.zipcode.toString() || null,
      tin: values.tin || null,
      country: values.country.value || null,
      state: values.state.value || null,
      industry: values.industry.value || null,
      timezone: values.timezone.value || null,
      currency: values.currency.value || null,
      logo: values.logo || null,
      place_id: (values.map && values.map.place_id) || null,
      latitude: (values.map && values.map.lat) || null,
      longitude: (values.map && values.map.lng) || null
    }
    //accounts/create_account
    try {
      if (!props.hasSellerAccount) {
        const response = await API.post(
          "/accounts/create_account",
          JSON.stringify(accountData)
        )
        const { data } = response
        const cachedUser = getCachedData("Qarabao_User")
        const userData = {
          ...props.currentUser,
          seller: data.seller,
          address: data.address
        }
        if (cachedUser) {
          cacheData("Qarabao_User", userData)
        }
        sessionData("Qarabao_User", userData)
        props.logInUser(userData)
        setSubmitting(false)
        props.history.push("/admin")
      } else {
        await API.put("/accounts/update_account", JSON.stringify(accountData))
        const sellerData = {
          account_id: values.account_id || null,
          currency: values.currency.value || null,
          id: values.id || null,
          industry: values.industry.value || null,
          logo: values.logo || null,
          name: values.name || null,
          timezone: values.timezone.value || null,
          tin: values.tin || null
        }
        const addressData = {
          id: props.currentUser.address.id,
          address_line_1: values.address1 || null,
          address_line_2: values.address2 || null,
          barangay: values.barangay.value || null,
          city: values.city.hasOwnProperty("value")
            ? values.city.value
            : values.city,
          zipcode: values.zipcode || null,
          country: values.country.value || null,
          province: values.state.value || null,
          place_id: (values.map && values.map.place_id) || null,
          lat: (values.map && values.map.lat) || null,
          lng: (values.map && values.map.lng) || null
        }
        const userData = {
          ...props.currentUser,
          seller: sellerData,
          address: addressData
        }
        const cachedUser = getCachedData("Qarabao_User")
        if (!cachedUser) {
          cacheData("Qarabao_User", userData)
        }
        sessionData("Qarabao_User", userData)
        console.log("User data: ", userData)
        setSubmitting(false)
        props.history.push("/admin")
      }
    } catch (error) {
      console.log("Account Error: ", error)
      if (error && error.response) {
        const { data } = error.response
        console.log("Data message: ", data.message)
        if (data && data.message === "Invalid TIN format!") {
          setErrors({
            tin: "Please enter the correct TIN format. (XXX-XXX-XXX-XXX)"
          })
        }
      }
      setSubmitting(false)
    }
  }
})(CreateAccountBaseForm)
function mapStateToProps(state) {
  const { account, address } = state.user
  let userInfoStatus =
    account.mobile !== "undefined" &&
    account.mobile !== "" &&
    account.mobile !== null &&
    (account.mobile_country_code !== "undefined" &&
      account.mobile_country_code !== "" &&
      account.mobile_country_code !== null)
      ? true
      : false
  let LatLngStatus =
    address &&
    address.lng !== "undefined" &&
    address.lng !== "" &&
    address.lng !== null &&
    (address.lat !== "undefined" && address.lat !== "" && address.lat !== null)
      ? true
      : false
  return {
    oldAccNoBrgy:
      address &&
      (address.barangay === null || address.barangay === "") &&
      address.country === "philippines",
    currentUser: state.user,
    hasSellerAccount:
      typeof state.user.seller !== "undefined" &&
      state.user.seller !== null &&
      typeof state.user.seller.account_id !== "undefined",
    hasUserInfo: userInfoStatus,
    hasLatLng: LatLngStatus
  }
}
export default withRouter(
  connect(
    mapStateToProps,
    { logInUser }
  )(CreateAccountForm)
)
